import { useState } from "react";
import {
  Form,
  Button,
  Card,
  Container,
  Row,
  Col
} from "react-bootstrap";

import API from "../services/api";
import { useNavigate } from "react-router-dom";
import {
  ShieldCheck,
  Eye,
  EyeSlash
} from "react-bootstrap-icons";

const Signup = () => {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isOtherBatch, setIsOtherBatch] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const batchOptions = [
    "Internship",
    "December",
    "January",
    "Other"
  ];

  const yearOptions = [
    "2025",
    "2026"
  ];

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    roll_no: "",
    batch: "",
    year: "",
    phone: "",
    email: "",
    password: ""
  });

  // 🔥 HANDLE CHANGE
  const handleChange = (key, value) => {
    setForm(prev => ({
      ...prev,
      [key]: value
    }));
  };

// if whatsapp otp want then remove the commment line and 

  // 🔥 SUBMIT
  // const handleSendOtp = async () => {

  //   if (loading) return;

  //   setLoading(true);

  //   try {

  //     const fd = new FormData();
  //     fd.append("phone", form.phone);
  //     fd.append("email", form.email);

  //     const res = await API.post("/auth/send-otp.php", fd);

  //     if (res.data.status === "success") {
  //       await handleSignup();
  //     } else {

  //       alert(res.data.msg);

  //       if (res.data.redirect === "login") {
  //         navigate("/login");
  //       }
  //     }

  //   } catch (err) {
  //     console.log(err);
  //     alert("Something went wrong");
  //   }

  //   setLoading(false);
  // };

  // 🔥 SIGNUP
  // const handleSignup = async () => {

  //   try {

  //     const fd = new FormData();

  //     Object.keys(form).forEach(key => {
  //       fd.append(key, form[key]);
  //     });

  //     const res = await API.post("/auth/signup.php", fd);

  //     if (res.data.status === "success") {

  //       localStorage.setItem("session_id", res.data.session_id);

  //       navigate("/enter-code");

  //     } else {

  //       alert(res.data.msg);

  //       if (res.data.redirect === "login") {
  //         navigate("/login");
  //       }
  //     }

  //   } catch (err) {
  //     console.log(err);
  //     alert("Signup failed");
  //   }
  // };

  //ENDS HERE

  const handleSignup = async () => {

    if (loading) return;
  
    setLoading(true);
  
    try {
  
      const fd = new FormData();
  
      Object.keys(form).forEach(key => {
        fd.append(key, form[key]);
      });
  
      const res = await API.post("/auth/signup.php", fd);
  
      if (res.data.status === "success") {
  
        localStorage.setItem("session_id", res.data.session_id);
  
        navigate("/enter-code");
  
      } else {
  
        alert(res.data.msg);
  
        if (res.data.redirect === "login") {
          navigate("/login");
        }
      }
  
    } catch (err) {
      console.log(err);
      alert("Signup failed");
    }
  
    setLoading(false);
  };

  return (

    <Container
      fluid
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4e9fd 100%)"
      }}
    >

      <Card
        className="shadow-lg border-0"
        style={{
          maxWidth: "520px",
          width: "100%",
          borderRadius: "20px"
        }}
      >

        <Card.Body className="p-4 p-md-5">

          {/* HEADER */}
          <div className="text-center mb-4">

            <ShieldCheck
              size={60}
              className="text-primary mb-3"
            />

            <h3 className="fw-bold">
              Exam Portal
            </h3>

            <p className="text-muted">
              Create your account to continue
            </p>

          </div>

          {/* FORM */}
          <Form>

            {/* NAME */}
            <Row>

              <Col md={6}>
                <Form.Group className="mb-3">

                  <Form.Label>
                    First Name
                  </Form.Label>

                  <Form.Control
                    value={form.first_name}
                    onChange={(e) =>
                      handleChange("first_name", e.target.value)
                    }
                    placeholder="Enter first name"
                    className="rounded-pill px-4 py-2"
                  />

                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">

                  <Form.Label>
                    Last Name
                  </Form.Label>

                  <Form.Control
                    value={form.last_name}
                    onChange={(e) =>
                      handleChange("last_name", e.target.value)
                    }
                    placeholder="Enter last name"
                    className="rounded-pill px-4 py-2"
                  />

                </Form.Group>
              </Col>

            </Row>

            {/* STUDENT ID */}
            {/* <Form.Group className="mb-3">

              <Form.Label>
                Student ID
              </Form.Label>

              <Form.Control
                value={form.roll_no}
                onChange={(e) =>
                  handleChange("roll_no", e.target.value)
                }
                placeholder="Enter student ID"
                className="rounded-pill px-4 py-2"
              />

            </Form.Group> */}

            {/* BATCH */}
            <Form.Group className="mb-3">

              <Form.Label>
                Batch
              </Form.Label>

              {!isOtherBatch ? (

                <Form.Select
                  value={form.batch}
                  onChange={(e) => {

                    const value = e.target.value;

                    if (value === "Other") {
                      setIsOtherBatch(true);
                      handleChange("batch", "");
                    } else {
                      handleChange("batch", value);
                    }
                  }}
                  className="rounded-pill px-4 py-2"
                >

                  <option value="">
                    Select Batch
                  </option>

                  {batchOptions.map((batch, i) => (
                    <option key={i} value={batch}>
                      {batch}
                    </option>
                  ))}

                </Form.Select>

              ) : (

                <Form.Control
                  value={form.batch}
                  onChange={(e) =>
                    handleChange("batch", e.target.value)
                  }
                  placeholder="Enter batch"
                  className="rounded-pill px-4 py-2"
                />

              )}

            </Form.Group>

            {/* YEAR */}
            <Form.Group className="mb-3">

              <Form.Label>
                Year
              </Form.Label>

              <Form.Select
                value={form.year}
                onChange={(e) =>
                  handleChange("year", e.target.value)
                }
                className="rounded-pill px-4 py-2"
              >

                <option value="">
                  Select Year
                </option>

                {yearOptions.map((year, i) => (
                  <option key={i} value={year}>
                    {year}
                  </option>
                ))}

              </Form.Select>

            </Form.Group>

            {/* PHONE */}
            <Form.Group className="mb-3">

              <Form.Label>
                Phone Number
              </Form.Label>

              <Form.Control
                value={form.phone}
                onChange={(e) =>
                  handleChange("phone", e.target.value)
                }
                placeholder="Enter phone number"
                className="rounded-pill px-4 py-2"
              />

            </Form.Group>

            {/* EMAIL */}
            <Form.Group className="mb-3">

              <Form.Label>
                Email Address
              </Form.Label>

              <Form.Control
                type="email"
                value={form.email}
                onChange={(e) =>
                  handleChange("email", e.target.value)
                }
                placeholder="Enter email"
                className="rounded-pill px-4 py-2"
              />

            </Form.Group>

          
         {/* PASSWORD */}
<Form.Group className="mb-4">

<Form.Label>
  Password
</Form.Label>

<div className="position-relative">

  <Form.Control
    type={showPassword ? "text" : "password"}
    value={form.password}
    onChange={(e) =>
      handleChange("password", e.target.value)
    }
    placeholder="Enter password"
    className="rounded-pill px-4 py-2 pe-5"
  />

  <span
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: "absolute",
      right: "18px",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      color: "#6c757d",
      zIndex: 10
    }}
  >

    {showPassword ? (
      <EyeSlash size={18} />
    ) : (
      <Eye size={18} />
    )}

  </span>

</div>

</Form.Group>

            {/* BUTTON */}
            <Button
              variant="primary"
              className="w-100 rounded-pill py-3 fw-bold"
              onClick={handleSignup}
              disabled={loading}
            >

              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Processing...
                </>
              ) : (
                "Submit & Continue"
              )}

            </Button>

          </Form>

        </Card.Body>
      </Card>
    </Container>
  );
};

export default Signup;